// extracted by mini-css-extract-plugin
module.exports = {"cakeEmoji":"_404-module--cake-emoji--2XUxr"};